<template>
  <div class="realize_wrap">
    <div class="realize_img">
      <div class="img_tit">
        <i :class="calcClass">{{$t("contactUs.bannerTitle")}}</i>
        <div class="img_desc">{{$t("contactUs.bannerTitleEn")}}</div>
      </div>
    </div>
    <div class="realize_nav_wrap">
      <div class="navigate">
        <div class="breadcrumb">
          <img class="home-icon" src="@/assets/img/home/home.png" alt=""/>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">{{$t("contactUs.title")}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{$t("nav.contact")}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <!--地图容器-->
      <div style="width: 100%; background-color:#fff;">
        <div class="amap-wrapper">
          <el-amap :vid="'amap-vue'"
                   :center="['114.063711', '22.534241']"
                   :zooms="[15,18]"
                   class="amap-box">
            <el-amap-text :text="infoWindowContent"/>
          </el-amap>
        </div>
      </div>
      <div style="width: 100%; background-color:#fff;">
        <div class="way">
          <div class="contact-item">
            <div class="icon phone-icon"></div>
            <div class="text">
              <p class="title">{{$t("contactUs.linkTitle")}}</p>
              <p class="content">{{$t("contactUs.linkContent")}}</p>
            </div>
          </div>
          <div class="contact-item">
            <div class="icon email-icon"></div>
            <div class="text">
              <p class="title">{{$t("contactUs.emailTitle")}}</p>
              <p class="content">{{$t("contactUs.emailContent")}}</p>
            </div>
          </div>
          <div class="contact-item">
            <div class="icon time-icon"></div>
            <div class="text">
              <p class="title">{{$t("contactUs.timeTitle")}}</p>
              <p class="content">{{$t("contactUs.timeContent")}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CallMe />
  </div>
</template>

<script>
/* eslint-disable */
import CallMe from '@/components/callme/index'
export default {
  computed: {
    infoWindowContent()
    {
      return `
          <div class="my-map" style="position: absolute; bottom: 0; left: 0;}">
            <div class="bottom-center amap-info-contentContainer">
              <div class="amap-info-content amap-info-outer">
                <p class="name" style="color: #000; font-size: 1rem; font-weight: bolder; border-bottom: 1px solid #ccc; padding-bottom: 10px;">${this.$t("contactUs.title")}</p>
                <p class="address" style="font-size: 1rem; margin-top: 10px;">${this.$t("contactUs.address")}</p>
      <!--          <a class="amap-info-close" href="javascript: void(0)" style="right: 5px;">×</a>-->
              </div>
      <!--        <div class="amap-info-sharp"></div>-->
            </div>
          </div>`
    },
    calcClass()
    {
      return (this.$i18n.locale === 'en' || this.$i18n.locale === 'ar') ? 'english-layout' : '';
    }
  },
  data() {
    return {
    }
  },
  methods: {
  },
  components: {
    CallMe
  },
  created(){
    this.tabSelectIndex = this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
  },
  mounted() {
  },
  watch: {
    $route() {
      this.tabSelectIndex = this.$route.path.substr(this.$route.path.length - 1) * 1 - 1
    },
  },
}
</script>

<style lang="scss" scoped>
.realize_wrap {
  position: relative;
  font-family: $font-family;
  background-color: #ffffff;
  .realize_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background-image: url('../../assets/img/website/contact-us1.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    .img_tit {
      width: 70%;
      font-weight: bold;
      margin: 0 auto;
      transition: all 0.5s ease 0s;
      i{
        font-size: $banner-font-size;
        border-bottom: 4px #fff solid;
        padding-bottom: 10px;
        @media screen and (max-width: 768px) {
          font-size: $phone-banner-font-size;
        }
      }
    }
    .img_desc {
      font-size: $banner-sub-font-size;
      margin-top: 15px;
      text-transform:uppercase;
      @media screen and (max-width: 768px) {
        font-size: $phone-banner-sub-font-size;
      }
      outline:none;
    }
    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        color: #fff;
        background: orange;
      }
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }
  .realize_nav_wrap {
    /*width: 100%;*/
    margin: 0 auto;
    @media screen and (max-width: 768px) {
      height: 50px;
    }
    .realize_nav {
      //height: 100%;
      display: flex;
      align-items: center;
      .active {
        font-weight: bold;
        color: #000;
      }
      .realize_item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .nav_top {
          font-size: 18px;
          @media screen and (max-width: 768px) {
            font-size: 14px;
          }
        }
        .nav_bottom {
          width: 30%;
          height: 4px;
          margin-top: 10px;
          background: #2091d3;
        }
      }
    }
  }
  .navigate{
    background-color: #f6f7f9;
    @media screen and (max-width: 768px) {
      background-color:#ffffff;
    }
  }
  .breadcrumb{
    width: $about-width;
    margin: 0 auto;
    padding: 20px 0px;
    box-sizing: border-box;
    display: flex;
    .home-icon{
      height: 20px;
      width: 20px;
      margin-right: 15px;
      @media screen and (max-width: 768px) {
        height:0;
        width: 0;
        margin-right:0
      }
    }
    .el-breadcrumb{
      margin-top: 4px;
    }
  }
  .amap-wrapper{
    width: $about-width;
    height: 620px;
    margin: 0 auto;
    padding: 0 0 20px 0;
    box-sizing: border-box;
    padding-top: 20px;
  }
  .amap-wrapper >>> .amap-overlay-text-container{
    color: #666666;
    padding: 5px;
    font-size: 32px;
  }
  .way{
    width: 70%;
    //margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    .contact-item {
      //margin: 0 10px;
      width: 32%;
      padding: 20px;
      box-sizing: border-box;
      background-color: #f2f2f2;
    }
    .icon {
      width: 50px;
      height: 50px;
      margin-right: 10px;
    }
    .phone-icon {
      background: url('../../assets/img/website/1.png') no-repeat center center;
      background-size: contain;
      margin-bottom: 20px;
    }
    .email-icon {
      background: url('../../assets/img/website/2.png') no-repeat center center;
      background-size: contain;
      margin-bottom: 20px;
    }
    .time-icon {
      background: url('../../assets/img/website/3.png') no-repeat center center;
      background-size: contain;
      margin-bottom: 20px;
    }
    .text {
      display: flex;
      flex-direction: column;
    }
    .title {
      font-weight: bolder;
      font-size: 18px;
      color: #000;
      margin-bottom: 5px;
    }
    .content {
      margin: 0;
      font-size: 18px;
      color: #666;
    }
  }
  @media screen and (max-width: 768px) {
    .breadcrumb{
      padding: 0.6rem 10px 0 0;
      box-sizing: border-box;
      background-color: #fff;
      margin-top: 10px;
      width: 90%;
      ::v-deep .el-breadcrumb{
        font-size: 0.8rem !important;
      }
    }
    .realize_nav_wrap {
      width: 100%;
      height: auto;
      margin-top: 0;
      margin-bottom: 50px;
    }
    .amap-wrapper{
      width: 90%;
      height: 40vh;
      margin: 1.5rem auto;
      box-sizing: border-box;
    }
    .amap-wrapper >>> .amap-overlay-text-container{
      color: #666666;
      padding: 5px;
      font-size: 32px;
    }
    .way{
      width: 90%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      //margin-top: 20px;
      .contact-item {
        width: 100%;
        margin-bottom: 20px;
        padding: 20px;
        box-sizing: border-box;
        background-color: #f2f2f2;
        font-size: 18px;
        .icon {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }
        .title {
          font-weight: bolder;
          font-size: 18px;
          color: #000;
          margin-bottom: 5px;
        }
        .content {
          margin: 0;
          font-size: 18px;
          color: #666;
        }
      }
    }
  }

  ::v-deep .amap-copyright{
    z-index: 0 !important;
  }

  ::v-deep .amap-logo{
    z-index: 0 !important;
  }

  @media (max-width: 480px) {
    .realize_nav_wrap {
      width: 100%;
      height: auto;
      margin-top: 0 !important;
      margin-bottom: 50px;
    }
  }

  ::v-deep .my-map{
    @media screen and (max-width: 768px) {
      transform: translateX(-30vw);
    }
  }
}
</style>
